import { render } from "./gap.vue?vue&type=template&id=524fdab1"
import script from "./gap.vue?vue&type=script&lang=js"
export * from "./gap.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__